import gql from "graphql-tag";

export const ORG_POC_SURVEY_LIST = gql`
query pocDashboardQueryOrgPocSurveyList($id: ID!) {
  organizationById(id: $id) {
    id
    surveySet(listing: true) {
      edges {
        node {
          id
          name
          multisourceResponse
        }
      }
    }
  }
}
`

export const ORG_POC_VERTICAL_SURVEY_RESPONSE = gql`
query pocDashboardQueryOrgPocVerticalSurveyResponse($id: ID!, $survey: ID, $user_FirstName: String, $first: Int, $cursor: String, $offset: Int) {
  vertical(id: $id) {
    id
    name
    employees(name: $user_FirstName, first: $first, after: $cursor, offset: $offset) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          teamMembersEmployee(vertical: $id) {
            edges {
              node {
                id
                name
              }
            }
          }
          teamManagerEmployee(vertical: $id) {
            edges {
              node {
                id
                name
              }
            }
          }
          user {
            id
            firstName
            lastName
            employee {
              id
            }
            profile {
              id
              profileImage
            }
            responseSet(survey: $survey, last: 1) {
              edges {
                node {
                  id
                  responseDate
                  survey {
                    id
                    multisourceResponse
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const TEAM_POC_ASSESSMENT_RESPONSE = gql`
query pocDashboardQueryTeamPocAssessmentResponse($id: ID!, $survey: ID, $user_FirstName: String, $first: Int, $cursor: String, $offset: Int) {
  Team(id: $id) {
    id
    name
    employees(name: $user_FirstName, first: $first, after: $cursor, offset: $offset) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          user {
            id
            firstName
            lastName
            employee {
              id
            }
            profile {
              id
              profileImage
            }
            responseSet(survey: $survey, last: 1) {
              edges {
                node {
                  id
                  responseDate
                  survey {
                    id
                    multisourceResponse
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_EMPLOYEE_LEVEL_COUNTS = gql`
query pocDashboardQueryOrgEmployeeLevelCounts($id: ID!) {
  organizationById(id: $id) {
    id
    employees {
      totalCount
    }
    ceo {
      id
      user {
        id
        firstName
      }
    }
    poc {
      edges {
        node {
          id
          user {
            id
          }
          verticalHeadEmployee {
            totalCount
          }
          teamManagerEmployee {
            totalCount
          }
        }
      }
    }
    verticalSet {
      totalCount
      edges {
        node {
          id
          heads {
            edges {
              node {
                id
                user {
                  id
                }
              }
            }
          }
        }
      }
      edges {
        node {
          teamSet {
            totalCount
            edges {
              node {
                id
                managers {
                  edges {
                    node {
                      id
                      user {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_SURVEY_BY_ID = gql`
query pocDashboardQueryOrgSurveyById($id: ID!) {
  SurveyById(id: $id) {
    id
    name
    multisourceResponse
  }
}
`

export const ORG_VERTICAL_DETAIL = gql`
query pocDashboardQueryOrgVerticalDetails($id: ID!) {
  vertical(id: $id) {
    id
    name
  }
}
`

export const ORG_SURVEY_360_REPORTS = gql`
query pocDashboardQueryresponseByResponseId($id: ID!) {
  responseByResponseId(id: $id) {
    id
    survey {
      id
      name
      responseSet(last: 1) {
        edges {
          node {
            responseDate
          }
        }
      }
    }
    report360
  }
}
`;

export const ORG_MANAGER_EMPLOYEE_COUNT = gql`
query pocDashboardQueryme {
  me {
    id
    employee {
      id
      teamManagerEmployee {
        totalCount
      }
      orgAmEmployee {
        totalCount
      }
      orgCeoEmployee {
        totalCount
      }
      orgPocEmployee {
        totalCount
      }
      verticalHeadEmployee {
        totalCount
      }
    }
  }
}
`;

export const ORG_USER_DETAIL = gql`
query pocDashboardQueryOrgUserDetail($id: ID!) {
  employeeById(id: $id) {
    id
    user {
      id
      firstName
      lastName
    }
  }
}
`

export const TEAM_ASSESSMENT_REPORTS = gql`
query pocDashboardQueryTeamAssessMentReport($user: ID, $id: ID, $orgId: ID!) {
  organizationById(id: $orgId) {
    id
    employees(user: $user) {
      edges {
        node {
          id
          user {
            id
            firstName
            responseSet(id: $id) {
              edges {
                node {
                  id
                  report360
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const SURVEY_BY_ID_FOR_REPORT = gql`
query pocDashboardQuerySurveyById($id:ID!){
    SurveyById(id:$id){
        id
        name
    }
}
`;

export const POC_MANAGER_EMPLOYEE_DETAIL = gql`
query pocDashboardQueryPocManagerEmployeeDetail {
  me {
    id
    employee {
      id
      teamManagerEmployee {
        totalCount
        edges {
          node {
            id
            employees {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      orgCeoEmployee {
        totalCount
        edges {
          node {
            id
            employees {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      orgPocEmployee {
        totalCount
        edges {
          node {
            id
            employees {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
      verticalHeadEmployee {
        totalCount
        edges {
          node {
            id
            employees {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                    email
                    employee {
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const ASSESSMENT_RESPONSE_SET_FOR_EMPLOYEE = gql`
  query organizationById($user: ID, $survey: ID, $id: ID!) {
  organizationById(id: $id) {
    id
    employees(user: $user) {
      edges {
        node {
          id
          user {
            id
            firstName
            responseSet(survey_Multisourceresponse: true, survey: $survey) {
              edges {
                node {
                  id
                  survey {
                    id
                    name
                  }
                  responseDuration
                  responseDate
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const VERTICAL_TOTAL_COUNT = gql`
query organizationById($id: ID!) {
  organizationById(id: $id) {
    id
    verticalSet {
      totalCount
    }
  }
}
`

export const LISCENCING_DETAIL = gql`
query pocDashboardQueryLicensesDetail($organization: ID, $id: ID!) {
  licenses: licenses(organization: $organization) {
    edges {
      node {
        plan {
          name
          licenses
        }
        expiry
      }
    }
  }
  organization: organizationById(id: $id) {
    id
    employees {
      totalCount
    }
  }
}
`

export const ANALYTICS = gql`
query pocDashboardQueryAnalytics($organizationId: ID){
  analytics(organizationId: $organizationId) {
    analyticsData
  }
}
`

export const ORG_POC_SURVEYS = gql`
query pocDashboardQueryOrgPocSurveys($id:  ID!) {
  organizationById(id: $id) {
    id
    surveySet(listing: true) {
      edges {
        node {
          id
          name
          multisourceResponse
          isGraduationTest
          surveyPath
          groupSet {
            edges {
              node {
                id
                questionSet {
                  totalCount
                  edges{
                    node{
                      id
                      gradingParameters
                      choiceSet(answerKey: true) {
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_POC_SURVEY_RESPONSE_SET = gql`
query pocDashboardQueryOrgPocSurveyResponseSet($survey: ID,$after:String,$first:Int,$user_FirstName_Icontains: String){
  surveyResponses(survey:$survey,after:$after,first:$first,user_FirstName_Icontains:$user_FirstName_Icontains){
    pageInfo{
      hasNextPage
      endCursor
    }
    edges{
      node{
        id
        survey{
          id
          groupSet{
            edges{
              node{
                id
                questionSet{
                  totalCount
                }
              }
            }
          }
        }
        user{
          id
          firstName
          lastName
          email
        }
        responseDate
        answerSet{
          edges{
            node{
              id
              answer
              question{
                id
                questionText
                choiceSet(answerKey:true){
                  edges{
                    node{
                      id
                      value
                      answerKey
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const QUERY_FOR_EXPORT_360_SURVEY_STATUS_REPORT = gql`
query pocDashboardQueryQueryForExport360SurveyStatusReport($survey: ID, $first: Int, $offset: Int, $id: ID!) {
  employee_list: organizationById(id: $id) {
    id
    employees(first: $first, offset: $offset) {
      pageInfo {
        hasNextPage
      }
      totalCount
      edges {
        node {
          id
          user {
            id
            email
            firstName
            lastName
            employee {
              id
              verticalMembersEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalHeadEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
            responseSet(survey: $survey, respondentType: "self", last: 1) {
              edges {
                node {
                  id
                  responseDate
                  multisourceResponseSet {
                    edges {
                      node {
                        user {
                          id
                          username
                        }
                        responseDate
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  invitation_list: tokenListByOrgId(first: $first, offset: $offset, survey: $survey, orgId: $id) {
    pageInfo {
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        user {
          id
          firstName
          lastName
          email
        }
        createdBy {
          id
          email
          firstName
          lastName
        }
        valid
        respondentType
        responseSourceFor {
          id
        }
      }
    }
  }
}
`
export const QUERY_FOR_EXPORT_360_SURVEY_DETAILED_REPORT = gql`
query pocDashboardQueryQueryForExport360SurveyDetailReport($survey: ID!, $id: ID!){
  export360SurveyData(survey:$survey, orgId:$id)
}`

export const ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET = gql`
query pocDashboardQueryOrgPocSurveyEmployeeResponseSet($survey: ID, $first: Int, $nameIcontains: String, $emailIcontains: String, $after: String, $offset: Int, $id: ID!) {
  organizationById(id: $id) {
    id
    employees(first: $first, name: $nameIcontains, user_Email: $emailIcontains, offset: $offset, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      edges {
        node {
          id
          user {
            id
            email
            firstName
            lastName
            employee {
              id
              verticalMembersEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalHeadEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
            responseSet(survey: $survey, respondentType: "self", last: 1) {
              edges {
                node {
                  id
                  responseDate
                  completed_invitation: multisourceResponseTokenSet(valid: false) {
                    totalCount
                  }
                  total_invitation: multisourceResponseTokenSet {
                    totalCount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360 = gql`
query pocDashboardQueryallOrgPocSurveyEmployeeResponseSetNon360(
  $survey: ID
  $first: Int
  $nameIcontains: String
  $emailIcontains: String
  $after: String
  $offset: Int
  $id: ID!
) {
  organizationById(id: $id) {
    id
    employees(
      first: $first
      name: $nameIcontains
      user_Email: $emailIcontains
      after: $after
      offset: $offset
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
      edges {
        node {
          id
          user {
            id
            email
            firstName
            lastName
            employee {
              id
              verticalMembersEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              verticalHeadEmployee {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
            responseSet(survey: $survey, respondentType: "self", last: 1) {
              edges {
                node {
                  id
                  responseDate
                  answerSet {
                    edges {
                      node {
                        id
                        answer
                        gradingParametersAnswers
                        question {
                          id
                          questionText
                          choiceSet(answerKey: true) {
                            edges {
                              node {
                                id
                                value
                                answerKey
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_DATE_RANGE = gql`
query SurveyById($survey:ID!,$first:Int,$after:String,$offset:Int,$responseDate_Range:[DateTime]){
  SurveyById(id:$survey){
    id
    responseSet(first:$first,after:$after,offset:$offset,responseDate_Range:$responseDate_Range, last:1){
      pageInfo{
        endCursor
        hasNextPage
      }
      totalCount
      edges{
        node{
          id
          user{
            id
            email
            firstName
            lastName
            employee{
              id
              verticalMembersEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
              verticalHeadEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
            }
            responseSet(survey:$survey,respondentType:"self",last:1){
              edges{
                node{
                  id 
                  responseDate
                  completed_invitation:multisourceResponseTokenSet(valid:false){
                    totalCount
                  }
                  total_invitation:multisourceResponseTokenSet{
                    totalCount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const ORG_POC_SURVEY_EMPLOYEE_RESPONSE_SET_NON_360_DATE_RANGE = gql`
query SurveyById($survey:ID!,$first:Int,$after:String,$offset:Int,$responseDate_Range:[DateTime]){
  SurveyById(id:$survey){
    id
    responseSet(first:$first,after:$after,offset:$offset,responseDate_Range:$responseDate_Range, last:1){
      pageInfo{
        endCursor
        hasNextPage
      }
      totalCount
      edges{
        node{
          id
          user{
            id
            email
            firstName
            lastName
            employee{
              id
              verticalMembersEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
              verticalHeadEmployee{
                edges{
                  node{
                    id
                    name
                  }
                }
              }
            }
            responseSet(last:1){
              edges{
                node{
                  id 
                  responseDate 
                  answerSet{
                    edges{
                      node{
                        id
                        answer
                        question{
                          id
                          questionText
                          choiceSet(answerKey:true){
                            edges{
                              node{
                                id
                                value
                                answerKey
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const VERTICAL_WISE_SURVEY_RESPONSES = gql`
query pocDashboardQueryVerticalWiseServeyResponses($survey:ID,$organization: ID,$first:Int,$name:String,$after:String,$offset:Int){
  verticals(organization: $organization, name: $name){
    edges{
      node{
        id
        name
        heads{
          edges{
            node{
              id
              user {
                id
                email
                firstName
                lastName
                employee {
                  id
                  verticalMembersEmployee {
                    edges {
                      node {
                        id
                        name
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  verticalHeadEmployee {
                    edges {
                      node {
                        id
                        name
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                responseSet(survey: "U3VydmV5VHlwZTozMw==", respondentType: "self", last: 1) {
                  edges {
                    node {
                      id
                      responseDate
                      answerSet {
                        edges {
                          node {
                            id
                            answer
                            question {
                              id
                              questionText
                              choiceSet(answerKey: true) {
                                edges {
                                  node {
                                    id
                                    value
                                    answerKey
                                    __typename
                                  }
                                  __typename
                                }
                                __typename
                              }
                              __typename
                            }
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
          }
        }
        employees(first:$first,offset:$offset,after:$after){
          pageInfo{
            endCursor
            hasNextPage
          }
          totalCount
          edges{
            node{
              id
              user{
                id
                email
                firstName
                lastName
                employee{
                  id
                  verticalMembersEmployee{
                    edges{
                      node{
                        id
                        name
                      }
                    }
                  }
                  verticalHeadEmployee{
                    edges{
                      node{
                        id
                        name
                      }
                    }
                  }
                }
                responseSet(survey:$survey,respondentType:"self",last:1){
                  edges{
                    node{
                      id 
                      responseDate
                      completed_invitation:multisourceResponseTokenSet(valid:false){
                        totalCount
                      }
                      total_invitation:multisourceResponseTokenSet{
                        totalCount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const VERTICAL_WISE_SURVEY_RESPONSES_NON_360 = gql`
query pocDashboardQueryVerticalWiseServeyResponsesNon360($survey:ID,$organization: ID,$first:Int,$name:String,$after:String,$offset:Int){
  verticals(organization: $organization, name: $name){
    edges{
      node{
        id
        name
        heads{
          edges{
            node{
              id
              user {
                id
                email
                firstName
                lastName
                employee {
                  id
                  verticalMembersEmployee {
                    edges {
                      node {
                        id
                        name
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  verticalHeadEmployee {
                    edges {
                      node {
                        id
                        name
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                responseSet(survey: "U3VydmV5VHlwZTozMw==", respondentType: "self", last: 1) {
                  edges {
                    node {
                      id
                      responseDate
                      answerSet {
                        edges {
                          node {
                            id
                            answer
                            question {
                              id
                              questionText
                              choiceSet(answerKey: true) {
                                edges {
                                  node {
                                    id
                                    value
                                    answerKey
                                    __typename
                                  }
                                  __typename
                                }
                                __typename
                              }
                              __typename
                            }
                            __typename
                          }
                          __typename
                        }
                        __typename
                      }
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
          }
        }
        employees(first:$first,after:$after,offset:$offset){
          pageInfo{
            endCursor
            hasNextPage
          }
          totalCount
          edges{
            node{
              id
              user{
                id
                email
                firstName
                lastName
                employee{
                  id
                  verticalMembersEmployee{
                    edges{
                      node{
                        id
                        name
                      }
                    }
                  }
                  verticalHeadEmployee{
                    edges{
                      node{
                        id
                        name
                      }
                    }
                  }
                }
                responseSet(survey:$survey,respondentType:"self",last:1){
                  edges{
                    node{
                      id 
                      responseDate 
                      answerSet{
                        edges{
                          node{
                            id
                            answer
                            question{
                              id
                              questionText
                              choiceSet(answerKey:true){
                                edges{
                                  node{
                                    id
                                    value
                                    answerKey
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

export const VERTICAL_LIST = gql`
query pocDashboardQueryVerticalList($organization: ID){
  verticals(organization: $organization){
    edges{
      node{
        id
        name
      }  
    }
  }
}
`

export const GET_SURVEY_REPORT_URL = gql`
query pocDashboardQueryGetSurveyReportURL($orgId: ID!, $survey: ID!) {
  exportSurveyExcel(survey: $survey, orgId: $orgId)
}
`